import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
    return {
        type: types.SET_LOADER,
        payload: data
    }
};

export const openProfileDrawer = () => {
        return ({
            type: types.GLOBAL_SHOW_PROFILE
        })
    };

export const hideProfileDrawer = () => {
        return ({
            type: types.GLOBAL_HIDE_PROFILE
        })
    };

export const  logoutUser = (history) => {
    return ({
        type: types.MODULE_AUTH_LOGOUT,
        history
    })
}

